import "./App.css";
import Section from "./Section";

import * as Images from "./images.js";

function App() {
    return (
        <div>
            <Section
                brief={
                    "Redesign a public service to help it connect with 18-30 year olds."
                }
                solution={
                    "I decided to re-brand First Bus as their logo had not been updated in \
                    years and their adverts were aimed at the older generation, thus they \
                    had very little appeal to 18-30 year olds. I took them from boring, \
                    outdated and corporate to professional, friendly and helpful."
                }
                bgCol={"bg-firstBusBg"}
                txtCol={"text-firstBusTxt"}
                slides={[
                    Images.bustimetables,
                    Images.businsta,
                    Images.citybus,
                    Images.buspattern,
                ]}
            />
            <Section
                brief={
                    "“To create a project that deals with the issue of improving human health \
                    and wellness”. - Creative Conscience 2021 Brief"
                }
                solution={
                    "OCD is a common disorder that is rarely spoken about in comparison to \
                    anxiety and depression. Watching my friend struggle with OCD and seeing \
                    others make fun of them for it made me realise the lack of awareness \
                    people have. To educate people on the disorder and create awareness of \
                    what OCD actually involves I created a campaign. Aimed at secondary school \
                    children it uses posters and social media to educate those who don’t \
                    suffer with it so they are able to empathise with those who do."
                }
                bgCol={"bg-ocdBg"}
                txtCol={"text-ocdTxt"}
                slides={[
                    Images.ocdbillboard,
                    Images.ocdinsta,
                    Images.ocdposter,
                    Images.ocddoor,
                    Images.ocdinstaprofile,
                    Images.ocdsanitiser,
                ]}
            />
            <Section
                brief={
                    "Choose a united nations sustainability and development goal and \
                    produce a campaign that addresses it and an issue \
                    related to ‘Sustainable Futures’."
                }
                solution={
                    "Working at McDonalds alongside my studies I realised \
                    how much food we waste. To reduce household waste I \
                    designed Eat2Live an app which provides families with \
                    ways of reusing their leftovers."
                }
                bgCol={"bg-mcdBg"}
                txtCol={"text-mcdTxt"}
                slides={[Images.mcd1, Images.mcd2, Images.mcd3, Images.mcd4]}
            />
            <Section
                brief={
                    "To create a self-Initiated project that demonstrates your\
                    skills as a designer. "
                }
                solution={
                    "Sickened by the news of Sarah Everard and the shocking \
                    statistics around harassment I designed an app to \
                    prevent women from being sexually harassed in pubs, \
                    clubs and bars. By taking a selfie women can discretely \
                    ask for help without anyone knowing."
                }
                bgCol={"bg-filtrBg"}
                txtCol={"text-filtrTxt"}
                slides={[
                    Images.flitrMockup,
                    Images.filtrPage,
                    Images.filtrLogo,
                    Images.filtrSink,
                    Images.filtrIcon,
                ]}
            />
            <Section
                brief={
                    "Create a new mass-appeal drinks brand with a\
                    distinctive and engaging sustainability story at its heart."
                }
                solution={
                    "According to the C&C Group in the drinks industry\
                    “agriculture uses 70% of global and 24% of European\
                    water”. So I decided to create a drinks brand which\
                    combats the over consumption and pollution of water\
                    through its production methods."
                }
                bgCol={"bg-astraBg"}
                txtCol={"text-adstraTxt"}
                slides={[
                    Images.astraeaBob,
                    Images.astraeaBeach,
                    Images.astraeaInsta,
                    Images.astraeaPoster,
                    Images.astraeaPoster2,
                    Images.astraeaTote,
                ]}
            />
        </div>
    );
}

export default App;
